export default {
  presenter: 'zandl',
  title: 'Open source router Turris v roce 2017 a výhledy na rok 2018',
  subtitle: 'začátečníci',
  text: `
Routery Turris mají v Česku celou řadu fanoušků. V roce 2017 se objevila celá řada nových funkcí,
hovoří se o přechodu na LEDE a především se ""zkomplikovala bezpečnostní situace"" kdy jedno
bezpečnostní riziko stíhá druhé. Jaký byl rok 2017 a co se chystá letos? A jak router obstojí
ve světě zvýšených bezpečnostních rizik?
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/zandl-turris.js